import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, unref as _unref, normalizeStyle as _normalizeStyle, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "container-full-1 bg-grey-50",
  style: {"margin":"0.5vh 0"}
}
const _hoisted_2 = {
  class: "s20 flex gap-2 py-1 position-relative",
  style: {"z-index":"1000","height":"40.5vh"}
}
const _hoisted_3 = { class: "s10 widget rounded-20 bg-gradient-dark flex flex-col justify-content-center h-100p px-7 py-7" }
const _hoisted_4 = { class: "s20 items-center gap-6 pb-6 collapse-content-flex active" }
const _hoisted_5 = { class: "s7_mobile" }
const _hoisted_6 = { class: "font-normal mt-2 mb-3" }
const _hoisted_7 = { class: "font-semibold my-2" }
const _hoisted_8 = { class: "font-semibold my-2" }
const _hoisted_9 = { class: "font-normal mt-4 mb-4" }
const _hoisted_10 = { class: "font-normal mt-2 mb-3" }
const _hoisted_11 = { class: "font-normal mt-2 mb-3" }
const _hoisted_12 = { class: "font-normal mt-2 mb-5" }
const _hoisted_13 = { class: "font-normal mb-4" }
const _hoisted_14 = { class: "s8_mobile px-6 mt-2" }
const _hoisted_15 = { class: "font-normal mb-4" }
const _hoisted_16 = { class: "font-normal mb-4" }
const _hoisted_17 = { class: "text-xl" }
const _hoisted_18 = { class: "font-normal mb-4" }
const _hoisted_19 = { class: "text-xl" }
const _hoisted_20 = { class: "font-normal mb-4" }
const _hoisted_21 = { class: "text-xl" }
const _hoisted_22 = { class: "font-normal mb-4" }
const _hoisted_23 = { class: "text-xl" }
const _hoisted_24 = { class: "font-normal mb-4" }
const _hoisted_25 = { class: "text-xl" }
const _hoisted_26 = {
  class: "h-60 rounded-100 position-relative",
  style: {"width":"100%","background-color":"rgba(var(--color-white-rgb), 0.1)"}
}
const _hoisted_27 = { class: "s10 h-100p widget rounded-20 bg-gradient-dark flex align-items-center justify-content-center gap-5 px-6 py-5" }
const _hoisted_28 = { class: "s8_mobile h-100p px-7" }
const _hoisted_29 = { class: "secondary-font font-bold text-white text-center" }
const _hoisted_30 = { class: "s11_mobile mt-2" }
const _hoisted_31 = { class: "grid2" }
const _hoisted_32 = {
  class: "widget shadow-200 flex align-items-center rounded-30 px-7 py-5",
  style: {"background-color":"rgba(var(--color-black-rgb), 0.5)"}
}
const _hoisted_33 = { class: "s14" }
const _hoisted_34 = { class: "secondary-font font-bold text-primary-color" }
const _hoisted_35 = {
  class: "widget shadow-200 flex align-items-center rounded-30 px-7 py-5",
  style: {"background-color":"rgba(var(--color-black-rgb), 0.8)"}
}
const _hoisted_36 = { class: "s14" }
const _hoisted_37 = { class: "secondary-font font-bold text-primary-color" }
const _hoisted_38 = {
  class: "widget shadow-200 flex align-items-center rounded-30 px-7 py-5",
  style: {"background-color":"rgba(var(--color-black-rgb), 0.8)"}
}
const _hoisted_39 = { class: "s14" }
const _hoisted_40 = { class: "secondary-font font-bold text-primary-color" }
const _hoisted_41 = {
  class: "widget shadow-200 flex align-items-center rounded-30 px-7 py-5",
  style: {"background-color":"rgba(var(--color-black-rgb), 0.8)"}
}
const _hoisted_42 = { class: "s14" }
const _hoisted_43 = { class: "secondary-font font-bold text-primary-color" }
const _hoisted_44 = {
  class: "widget shadow-200 flex align-items-center rounded-30 px-7 py-5",
  style: {"background-color":"rgba(var(--color-black-rgb), 0.5)"}
}
const _hoisted_45 = { class: "s6" }
const _hoisted_46 = { class: "secondary-font font-normal text-grey-100" }
const _hoisted_47 = { class: "s14" }
const _hoisted_48 = { class: "secondary-font font-bold text-primary-color" }
const _hoisted_49 = {
  class: "widget shadow-200 flex align-items-center rounded-30 px-7 py-5",
  style: {"background-color":"rgba(var(--color-black-rgb), 0.5)"}
}
const _hoisted_50 = { class: "s14" }
const _hoisted_51 = { class: "secondary-font font-bold text-primary-color" }
const _hoisted_52 = {
  class: "s20 flex gap-2 py-1",
  style: {"height":"58.5vh"}
}
const _hoisted_53 = {
  class: "s10 widget border rounded-20 shadow-100 pb-1 h-100p",
  style: {"overflow-y":"scroll"}
}
const _hoisted_54 = { class: "s10 widget border rounded-20 h-100p px-6 pt-4 pb-1" }
const _hoisted_55 = { class: "s10_mobile px-4" }
const _hoisted_56 = { class: "card-carte" }
const _hoisted_57 = { class: "card-carte-floating" }
const _hoisted_58 = { class: "s20" }
const _hoisted_59 = { class: "flex align-items-center gap-2" }
const _hoisted_60 = { class: "secondary-font text-6xl" }
const _hoisted_61 = { class: "grid3 px-6" }
const _hoisted_62 = { class: "font-normal text-grey-500 text-center py-0" }
const _hoisted_63 = { class: "text-2xl text-grey-800" }
const _hoisted_64 = { class: "font-normal text-grey-500 text-center py-0" }
const _hoisted_65 = { class: "text-2xl text-grey-800" }
const _hoisted_66 = { class: "font-normal text-grey-500 text-center py-0" }
const _hoisted_67 = { class: "text-2xl text-grey-800" }
const _hoisted_68 = { class: "font-normal text-grey-500 text-center py-0" }
const _hoisted_69 = { class: "text-2xl text-grey-800" }
const _hoisted_70 = { class: "font-normal text-grey-500 text-center py-0" }
const _hoisted_71 = { class: "text-2xl text-grey-800" }
const _hoisted_72 = { class: "font-normal text-grey-500 text-center py-0" }
const _hoisted_73 = { class: "text-2xl text-grey-800" }
const _hoisted_74 = { class: "font-normal text-grey-500 text-center py-0" }
const _hoisted_75 = { class: "text-2xl text-grey-800" }
const _hoisted_76 = { class: "font-normal text-grey-500 text-center py-0" }
const _hoisted_77 = { class: "text-2xl text-grey-800" }
const _hoisted_78 = { class: "font-normal text-grey-500 text-center py-0" }
const _hoisted_79 = { class: "text-2xl text-grey-800" }
const _hoisted_80 = { class: "font-normal text-grey-500 text-center py-0" }
const _hoisted_81 = { class: "text-2xl text-grey-800" }
const _hoisted_82 = { class: "font-normal text-grey-500 text-center py-0" }
const _hoisted_83 = { class: "text-2xl text-grey-800" }

import CircularSlider from '@/components/CircularSlider.vue';
import { useToastStore } from '@/stores/toast.store';
import { formatAmount, formatDateFrench, generateUUID, MONTHS_FR } from '@/utils';
import UserPlanMensuel from '@/views/users/@components/UserPlanMensuel.vue';
import axios from 'axios';
import moment from 'moment';
import { inject, onMounted, reactive, Ref, ref, watch } from 'vue';
import { useRoute } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'ProspectsSimulation',
  setup(__props) {

const route = useRoute();
const toastStore = useToastStore();
const loadingSimulation = ref(false);
const prospect = ref(route.meta.item as any);
const prelevementPourcentInput = ref(prospect.value.quotite_cessible_max ?? 20);
const souscription = reactive({} as any);
const planMensuelDatas = reactive({ id: null as any, plan_mensuel: [] as any, title: null });

onMounted(() => {
    calculateSimulation();
})

function onCursorChanged() {
    calculateSimulation();
}

async function calculateSimulation() {
    try {
        loadingSimulation.value = true;
        const response = await axios.post(`/backoffice/prospects/${prospect.value.id}/simulate_souscription`, { prelevementPourcent: prelevementPourcentInput.value });
        Object.assign(souscription, response.data.souscription);
        Object.assign(planMensuelDatas, {
            id: generateUUID(),
            plan_mensuel: response.data.plan_mensuel,
            title: getTitlePlanMensuel(souscription.date_debut, souscription.date_fin, 0)
        });
    } catch(error: any) {
        toastStore.error(error.message || 'Une erreur est survenue lors du rejet des prospects.');
    } finally {
        loadingSimulation.value = false;
    }
}

function getTitlePlanMensuel(dateDebut: string, dateFin: string, offset: number) {
    const dateDebutM = moment(dateDebut);
    const dateFinM = moment(dateFin);

    return `Année ${(offset + 1)} / ${MONTHS_FR[dateDebutM.month()]} ${dateDebutM.format('YYYY')} - ${MONTHS_FR[dateFinM.month()]} ${dateFinM.format('YYYY')}`;
}

function calculateAnciennete(dateEngagement: string | null): string {
    if (!dateEngagement) return '-';
    try {
        const engagementDate = moment(dateEngagement);
        if (!engagementDate.isValid()) return '-';
        const now = moment();
        const years = now.diff(engagementDate, 'years');
        const months = now.diff(engagementDate, 'months') % 12;
        
        if (years > 0 && months > 0) {
            return `${years} an${years > 1 ? 's' : ''} ${months} mois`;
        } else if (years > 0) {
            return `${years} an${years > 1 ? 's' : ''}`;
        } else if (months > 0) {
            return `${months} mois`;
        } else {
            return '0 mois';
        }
    } catch {
        return '-';
    }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("section", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[20] || (_cache[20] = _createStaticVNode("<div class=\"s4_mobile px-4 text-center\"><div class=\"rounded-100 overflow-hidden item active\"><img src=\"/assets/users_avatar/600w/user.jpg\" width=\"100%\"></div><div class=\"clear-both h-15\"></div><span class=\"tag-state warning stroke\">En cours</span><span class=\"tag-state notif stroke\">Actif</span><h3 class=\"mt-5 text-center\">C788PMKJ</h3><p class=\"flex gap-2 text-grey-200 my-3\"><img src=\"/icons/icon-calendrier.svg\" class=\"size-xs\"> Dernière connexion: 13/12/2025</p></div>", 1)),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h3", null, _toDisplayString(prospect.value.nom + ' ' + prospect.value.prenom), 1),
            _createElementVNode("h4", _hoisted_6, _toDisplayString(prospect.value.collectivite.nom), 1),
            _createElementVNode("h6", _hoisted_7, _toDisplayString(prospect.value.telephone || 'N/A'), 1),
            _createElementVNode("h6", _hoisted_8, _toDisplayString(prospect.value.email || 'N/A'), 1),
            _createElementVNode("h4", _hoisted_9, [
              _cache[1] || (_cache[1] = _createTextVNode(" Date de naissance ", -1)),
              _cache[2] || (_cache[2] = _createElementVNode("br", { class: "mb-3" }, null, -1)),
              _createElementVNode("b", null, _toDisplayString(_unref(formatDateFrench)(prospect.value.date_naissance)) + " - " + _toDisplayString(calculateAnciennete(prospect.value.date_naissance)), 1)
            ]),
            _cache[5] || (_cache[5] = _createElementVNode("hr", { class: "hr-white" }, null, -1)),
            _createElementVNode("h4", _hoisted_10, _toDisplayString(prospect.value.identifiant_ag), 1),
            _createElementVNode("h5", _hoisted_11, _toDisplayString(prospect.value.fonction_ag), 1),
            _createElementVNode("h5", _hoisted_12, _toDisplayString(prospect.value.cpte_fonct_ag + ' / ' + prospect.value.categ_ag), 1),
            _cache[6] || (_cache[6] = _createElementVNode("hr", { class: "hr-white" }, null, -1)),
            _createElementVNode("h6", _hoisted_13, [
              _cache[3] || (_cache[3] = _createTextVNode(" Date d'engagement ", -1)),
              _cache[4] || (_cache[4] = _createElementVNode("br", { class: "mb-2" }, null, -1)),
              _createElementVNode("b", null, _toDisplayString(_unref(formatDateFrench)(prospect.value.date_engagement)) + " - " + _toDisplayString(calculateAnciennete(prospect.value.date_engagement)), 1)
            ])
          ]),
          _cache[21] || (_cache[21] = _createElementVNode("div", null, [
            _createElementVNode("hr", { class: "hr-vertical hr-vertical-white h-100p" })
          ], -1)),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("h4", _hoisted_15, [
              _cache[7] || (_cache[7] = _createTextVNode(" Av. retraite ", -1)),
              _cache[8] || (_cache[8] = _createElementVNode("br", { class: "mb-3" }, null, -1)),
              _createElementVNode("b", null, _toDisplayString(prospect.value.eta_retraite) + " année(s)", 1)
            ]),
            _createElementVNode("h5", _hoisted_16, [
              _cache[9] || (_cache[9] = _createTextVNode(" Date d'import ", -1)),
              _cache[10] || (_cache[10] = _createElementVNode("br", { class: "mb-2" }, null, -1)),
              _createElementVNode("b", _hoisted_17, _toDisplayString(_unref(formatDateFrench)(prospect.value.created_at)), 1)
            ]),
            _createElementVNode("h5", _hoisted_18, [
              _cache[11] || (_cache[11] = _createTextVNode(" Date de fin de souscription ", -1)),
              _cache[12] || (_cache[12] = _createElementVNode("br", { class: "mb-2" }, null, -1)),
              _createElementVNode("b", _hoisted_19, _toDisplayString(souscription?.date_fin ? _unref(formatDateFrench)(souscription.date_fin) : 'N/A'), 1)
            ]),
            _cache[19] || (_cache[19] = _createElementVNode("hr", { class: "hr-white" }, null, -1)),
            _createElementVNode("h5", _hoisted_20, [
              _cache[13] || (_cache[13] = _createTextVNode(" Utilisation total ", -1)),
              _cache[14] || (_cache[14] = _createElementVNode("br", { class: "mb-2" }, null, -1)),
              _createElementVNode("b", _hoisted_21, _toDisplayString(souscription?.utilisation_total !== undefined ? _unref(formatAmount)(souscription.utilisation_total) : 'N/A'), 1)
            ]),
            _createElementVNode("h5", _hoisted_22, [
              _cache[15] || (_cache[15] = _createTextVNode(" Salaire Net après Utilisation ", -1)),
              _cache[16] || (_cache[16] = _createElementVNode("br", { class: "mb-2" }, null, -1)),
              _createElementVNode("b", _hoisted_23, _toDisplayString(souscription?.salaire_net !== undefined ? _unref(formatAmount)(souscription.salaire_net) : 'N/A'), 1)
            ]),
            _createElementVNode("h5", _hoisted_24, [
              _cache[17] || (_cache[17] = _createTextVNode(" Quotité cessible disponible ", -1)),
              _cache[18] || (_cache[18] = _createElementVNode("br", { class: "mb-2" }, null, -1)),
              _createElementVNode("b", _hoisted_25, _toDisplayString(souscription?.quotite_cessible_montant !== undefined ? _unref(formatAmount)(souscription.quotite_cessible_montant) : 'N/A'), 1)
            ])
          ])
        ]),
        _cache[23] || (_cache[23] = _createElementVNode("div", { class: "clear-both h-0" }, null, -1)),
        _createElementVNode("div", _hoisted_26, [
          _cache[22] || (_cache[22] = _createElementVNode("div", { class: "widget-floating py-0 text-xl flex-right" }, "Utilisation", -1)),
          _createElementVNode("div", {
            class: "h-100p flex align-items-center justify-content-left rounded-100 text-2xl px-5 bg-pop-green",
            style: _normalizeStyle(`width: ${souscription?.prelevement_pourcent !== undefined ? _unref(formatAmount)(souscription.prelevement_pourcent) : 0}%;`)
          }, _toDisplayString(souscription?.prelevement_pourcent !== undefined ? _unref(formatAmount)(souscription.prelevement_pourcent) : 0) + "% ", 5)
        ])
      ]),
      _createElementVNode("section", _hoisted_27, [
        _createElementVNode("div", _hoisted_28, [
          _cache[24] || (_cache[24] = _createElementVNode("div", { class: "container-full-2 s20 mb-0" }, [
            _createElementVNode("h3", { class: "font-semibold mt-5 text-center" }, "Simulateur de souscription")
          ], -1)),
          _createVNode(CircularSlider, {
            modelValue: prelevementPourcentInput.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((prelevementPourcentInput).value = $event)),
            onChange: onCursorChanged,
            min: souscription?.quotite_cessible_min !== undefined ? souscription.quotite_cessible_min : 0,
            max: souscription?.quotite_cessible_max !== undefined ? souscription.quotite_cessible_max : 100,
            step: 1,
            size: 380,
            "stroke-width": 18,
            keepBaseScale: true,
            color: "#5CE6A6",
            "track-color": "rgba(92,230,166,0.25)",
            unit: "%"
          }, null, 8, ["modelValue", "min", "max"]),
          _createElementVNode("h1", _hoisted_29, _toDisplayString(souscription?.prelevement_montant !== undefined ? _unref(formatAmount)(souscription.prelevement_montant) : 'N/A'), 1),
          _cache[25] || (_cache[25] = _createElementVNode("h4", { class: "font-semibold mt-3 text-center" }, "Prélèvement sur salaire", -1))
        ]),
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("div", _hoisted_32, [
              _cache[27] || (_cache[27] = _createElementVNode("div", { class: "s6" }, [
                _createElementVNode("h2", { class: "secondary-font font-normal text-grey-100" }, "Net"),
                _createElementVNode("h4", { class: "secondary-font font-normal text-grey-100" })
              ], -1)),
              _createElementVNode("div", _hoisted_33, [
                _cache[26] || (_cache[26] = _createElementVNode("h6", { class: "secondary-font font-medium text-grey-100 mb-1" }, "Salaire", -1)),
                _createElementVNode("h2", _hoisted_34, _toDisplayString(souscription?.salaire !== undefined ? _unref(formatAmount)(souscription.salaire) : 'N/A'), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_35, [
              _cache[29] || (_cache[29] = _createElementVNode("div", { class: "s6" }, [
                _createElementVNode("h2", { class: "secondary-font font-normal text-grey-100" }, "Par"),
                _createElementVNode("h4", { class: "secondary-font font-normal text-grey-100" }, "mois")
              ], -1)),
              _createElementVNode("div", _hoisted_36, [
                _cache[28] || (_cache[28] = _createElementVNode("h6", { class: "secondary-font font-medium text-grey-100 mb-1" }, "Mon revolving", -1)),
                _createElementVNode("h2", _hoisted_37, _toDisplayString(souscription?.solde_utilisable !== undefined ? _unref(formatAmount)(souscription.solde_utilisable) : 'N/A'), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_38, [
              _cache[31] || (_cache[31] = _createElementVNode("div", { class: "s6" }, [
                _createElementVNode("h2", { class: "secondary-font font-normal text-grey-100" }, "12"),
                _createElementVNode("h4", { class: "secondary-font font-normal text-grey-100" }, "mois")
              ], -1)),
              _createElementVNode("div", _hoisted_39, [
                _cache[30] || (_cache[30] = _createElementVNode("h6", { class: "secondary-font font-medium text-grey-100 mb-1" }, "Revolving sur 12 mois", -1)),
                _createElementVNode("h2", _hoisted_40, _toDisplayString(souscription?.pouvoir_achat_an !== undefined ? _unref(formatAmount)(souscription.pouvoir_achat_an) : 'N/A'), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_41, [
              _cache[33] || (_cache[33] = _createElementVNode("div", { class: "s6" }, [
                _createElementVNode("h2", { class: "secondary-font font-normal text-grey-100" }, "36"),
                _createElementVNode("h4", { class: "secondary-font font-normal text-grey-100" }, "mois")
              ], -1)),
              _createElementVNode("div", _hoisted_42, [
                _cache[32] || (_cache[32] = _createElementVNode("h6", { class: "secondary-font font-medium text-grey-100 mb-1" }, "Revolving sur 36 mois", -1)),
                _createElementVNode("h2", _hoisted_43, _toDisplayString(souscription?.pouvoir_achat !== undefined ? _unref(formatAmount)(souscription.pouvoir_achat) : 'N/A'), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_44, [
              _createElementVNode("div", _hoisted_45, [
                _createElementVNode("h2", _hoisted_46, _toDisplayString(souscription?.prelevement_pourcent !== undefined ? souscription?.prelevement_pourcent + '%' : 'N/A'), 1),
                _cache[34] || (_cache[34] = _createElementVNode("h4", { class: "secondary-font font-normal text-grey-100" }, null, -1))
              ]),
              _createElementVNode("div", _hoisted_47, [
                _cache[35] || (_cache[35] = _createElementVNode("h6", { class: "secondary-font font-medium text-grey-100 mb-1" }, "Prélèvement sur salaire", -1)),
                _createElementVNode("h2", _hoisted_48, _toDisplayString(souscription?.prelevement_montant !== undefined ? _unref(formatAmount)(souscription.prelevement_montant) : 'N/A'), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_49, [
              _cache[37] || (_cache[37] = _createElementVNode("div", { class: "s6" }, [
                _createElementVNode("h2", { class: "secondary-font font-normal text-grey-100" }, "36"),
                _createElementVNode("h4", { class: "secondary-font font-normal text-grey-100" }, "mois")
              ], -1)),
              _createElementVNode("div", _hoisted_50, [
                _cache[36] || (_cache[36] = _createElementVNode("h6", { class: "secondary-font font-medium text-grey-100 mb-1" }, "Prélèvement sur 36 mois", -1)),
                _createElementVNode("h2", _hoisted_51, _toDisplayString(souscription?.prelevement_montant_3_an !== undefined ? _unref(formatAmount)(souscription.prelevement_montant_3_an) : 'N/A'), 1)
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_52, [
      _createElementVNode("section", _hoisted_53, [
        (planMensuelDatas.id)
          ? (_openBlock(), _createBlock(UserPlanMensuel, {
              key: 0,
              "plan-mensuel": planMensuelDatas.plan_mensuel!,
              title: planMensuelDatas.title!
            }, null, 8, ["plan-mensuel", "title"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("section", _hoisted_54, [
        _cache[75] || (_cache[75] = _createElementVNode("div", { class: "container-full-2 s20 mb-5" }, [
          _createElementVNode("h4", { class: "font-semibold mt-3" }, "Carte / Utilisation / Données")
        ], -1)),
        _createElementVNode("div", _hoisted_55, [
          _createElementVNode("div", _hoisted_56, [
            _createElementVNode("div", _hoisted_57, [
              _createElementVNode("div", _hoisted_58, [
                _cache[40] || (_cache[40] = _createElementVNode("h5", { class: "secondary-font font-bold mb-3" }, "Solde utilisable", -1)),
                _createElementVNode("div", _hoisted_59, [
                  _createElementVNode("h1", _hoisted_60, _toDisplayString(souscription?.solde_utilisable !== undefined ? _unref(formatAmount)(souscription.solde_utilisable) : 'N/A'), 1),
                  _cache[38] || (_cache[38] = _createElementVNode("h2", { class: "secondary-font text-4xl mt-2" }, "F", -1)),
                  _cache[39] || (_cache[39] = _createElementVNode("div", { class: "mt-2 ml-2" }, [
                    _createElementVNode("img", {
                      src: "/icons/icon-eye-off.svg",
                      class: "size-medium icon-white"
                    })
                  ], -1))
                ]),
                _cache[41] || (_cache[41] = _createStaticVNode("<div class=\"card-carte-floating-bottom\"><h5 class=\"s10 secondary-font font-bold\">*** *** **** 1212</h5><div class=\"s10 flex-right align-items-center gap-2\"><img src=\"/icons/icon-edit.svg\" class=\"size-medium icon-white\"><h5 class=\"secondary-font font-bold\">Commerce</h5></div></div>", 1))
              ])
            ]),
            _cache[42] || (_cache[42] = _createElementVNode("img", {
              src: "/images/carte_coop_light.png",
              class: "card-carte-img"
            }, null, -1))
          ])
        ]),
        _cache[76] || (_cache[76] = _createStaticVNode("<div class=\"s10_mobile px-4\"><div class=\"card-carte\"><div class=\"card-carte-floating\"><div class=\"s20\"><h5 class=\"secondary-font font-bold mb-3\">Numéro de carte</h5><div class=\"flex align-items-center gap-2\"><h1 class=\"secondary-font text-6xl\">***1212</h1></div><div class=\"card-carte-floating-bottom\"><h5 class=\"s10 secondary-font font-bold\">*** *** **** 1212</h5></div></div></div><img src=\"/images/carte_coop_verso.png\" class=\"card-carte-img\"></div></div><div class=\"clear-both h-40\"></div>", 2)),
        _createElementVNode("div", _hoisted_61, [
          _createElementVNode("h6", _hoisted_62, [
            _cache[43] || (_cache[43] = _createTextVNode(" Taux Interets Microfinance", -1)),
            _cache[44] || (_cache[44] = _createElementVNode("br", { class: "mb-1" }, null, -1)),
            _createElementVNode("b", _hoisted_63, _toDisplayString(souscription?.taux_interets !== undefined ? souscription.taux_interets + '%' : 'N/A'), 1),
            _cache[45] || (_cache[45] = _createElementVNode("hr", null, null, -1))
          ]),
          _createElementVNode("h6", _hoisted_64, [
            _cache[46] || (_cache[46] = _createTextVNode(" Prélèvement sur salaire % ", -1)),
            _cache[47] || (_cache[47] = _createElementVNode("br", { class: "mb-1" }, null, -1)),
            _createElementVNode("b", _hoisted_65, _toDisplayString(souscription?.prelevement_pourcent !== undefined ? souscription.prelevement_pourcent + '%' : 'N/A'), 1),
            _cache[48] || (_cache[48] = _createElementVNode("hr", null, null, -1))
          ]),
          _createElementVNode("h6", _hoisted_66, [
            _cache[49] || (_cache[49] = _createTextVNode(" Prélèvement sur salaire", -1)),
            _cache[50] || (_cache[50] = _createElementVNode("br", { class: "mb-1" }, null, -1)),
            _createElementVNode("b", _hoisted_67, _toDisplayString(souscription?.prelevement_montant !== undefined ? _unref(formatAmount)(souscription.prelevement_montant) : 'N/A'), 1),
            _cache[51] || (_cache[51] = _createElementVNode("hr", null, null, -1))
          ]),
          _createElementVNode("h6", _hoisted_68, [
            _cache[52] || (_cache[52] = _createTextVNode(" Ans pour la Retraite", -1)),
            _cache[53] || (_cache[53] = _createElementVNode("br", { class: "mb-1" }, null, -1)),
            _createElementVNode("b", _hoisted_69, _toDisplayString(prospect.value.eta_retraite !== undefined ? Math.abs(prospect.value.eta_retraite) + ' ans' : 'N/A'), 1),
            _cache[54] || (_cache[54] = _createElementVNode("hr", null, null, -1))
          ]),
          _createElementVNode("h6", _hoisted_70, [
            _cache[55] || (_cache[55] = _createTextVNode(" Quotité cessible max %", -1)),
            _cache[56] || (_cache[56] = _createElementVNode("br", { class: "mb-1" }, null, -1)),
            _createElementVNode("b", _hoisted_71, _toDisplayString(souscription?.quotite_cessible_max !== undefined ? souscription.quotite_cessible_max + '%' : 'N/A'), 1),
            _cache[57] || (_cache[57] = _createElementVNode("hr", null, null, -1))
          ]),
          _createElementVNode("h6", _hoisted_72, [
            _cache[58] || (_cache[58] = _createTextVNode(" Quotité cessible max", -1)),
            _cache[59] || (_cache[59] = _createElementVNode("br", { class: "mb-1" }, null, -1)),
            _createElementVNode("b", _hoisted_73, _toDisplayString(prospect.value.quotite_cessible_montant !== undefined ? _unref(formatAmount)(prospect.value.quotite_cessible_montant) : 'N/A'), 1),
            _cache[60] || (_cache[60] = _createElementVNode("hr", null, null, -1))
          ]),
          _createElementVNode("h6", _hoisted_74, [
            _cache[61] || (_cache[61] = _createTextVNode(" Pret à Rembourser apres 3 Ans", -1)),
            _cache[62] || (_cache[62] = _createElementVNode("br", { class: "mb-1" }, null, -1)),
            _createElementVNode("b", _hoisted_75, _toDisplayString(souscription?.pret_rembourser !== undefined ? _unref(formatAmount)(souscription.pret_rembourser) : 'N/A'), 1),
            _cache[63] || (_cache[63] = _createElementVNode("hr", null, null, -1))
          ]),
          _createElementVNode("h6", _hoisted_76, [
            _cache[64] || (_cache[64] = _createTextVNode(" Cash-Back TVA Attendu", -1)),
            _cache[65] || (_cache[65] = _createElementVNode("br", { class: "mb-1" }, null, -1)),
            _createElementVNode("b", _hoisted_77, _toDisplayString(souscription?.cashback_tva !== undefined ? _unref(formatAmount)(souscription.cashback_tva) : 'N/A'), 1),
            _cache[66] || (_cache[66] = _createElementVNode("hr", null, null, -1))
          ]),
          _createElementVNode("h6", _hoisted_78, [
            _cache[67] || (_cache[67] = _createTextVNode(" Prêt en Concession", -1)),
            _cache[68] || (_cache[68] = _createElementVNode("br", { class: "mb-1" }, null, -1)),
            _createElementVNode("b", _hoisted_79, _toDisplayString(souscription?.pret_concession !== undefined ? _unref(formatAmount)(souscription.pret_concession) : 'N/A'), 1),
            _cache[69] || (_cache[69] = _createElementVNode("hr", null, null, -1))
          ]),
          _createElementVNode("h6", _hoisted_80, [
            _cache[70] || (_cache[70] = _createTextVNode(" Prélèvement à la Solde", -1)),
            _cache[71] || (_cache[71] = _createElementVNode("br", { class: "mb-1" }, null, -1)),
            _createElementVNode("b", _hoisted_81, _toDisplayString(souscription?.prelevement_solde !== undefined ? _unref(formatAmount)(souscription.prelevement_solde) : 'N/A'), 1)
          ]),
          _createElementVNode("h6", _hoisted_82, [
            _cache[72] || (_cache[72] = _createTextVNode(" Pret à Rembourser", -1)),
            _cache[73] || (_cache[73] = _createElementVNode("br", { class: "mb-1" }, null, -1)),
            _createElementVNode("b", _hoisted_83, _toDisplayString(souscription?.pret_rembourser_an !== undefined ? _unref(formatAmount)(souscription.pret_rembourser_an) : 'N/A'), 1)
          ]),
          _cache[74] || (_cache[74] = _createElementVNode("h6", { class: "font-normal text-grey-500 text-center py-0" }, [
            _createTextVNode(" Durée Financement "),
            _createElementVNode("br", { class: "mb-1" }),
            _createElementVNode("b", { class: "text-2xl text-grey-800" }, "36 Mois"),
            _createTextVNode(" - "),
            _createElementVNode("b", { class: "text-2xl text-grey-800" }, "3 ans")
          ], -1))
        ])
      ])
    ])
  ]))
}
}

})